module.exports = "<p>\r\n  company-registration-entry works!\r\n</p>\r\n"